export enum PageMode {
    ContinuousScroll,
    SinglePage
}
